import { Injectable, inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Route,
	RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthState } from 'src/shared/state/auth.state';

@Injectable({
	providedIn: 'root',
})
export class AdminRoleGuard {
	private store = inject(Store);

	isAdmin: Observable<boolean> = this.store.select(AuthState.isAdmin);

	canLoad(_route: Route): boolean {
		return this.store.selectSnapshot(AuthState.isAdmin);
	}

	canActivate(
		_route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Observable<boolean> {
		return this.isAdmin;
	}
}
